import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');

  // Update language when URL parameter changes
  useEffect(() => {
    console.log('LanguageContext - lang param:', lang);
    console.log('LanguageContext - currentLanguage:', currentLanguage);
    console.log('LanguageContext - i18n.language:', i18n.language);
    
    if (lang && ['en', 'fr'].includes(lang) && currentLanguage !== lang) {
      console.log('LanguageContext - Changing language to:', lang);
      setCurrentLanguage(lang);
      i18n.changeLanguage(lang);
    }
  }, [lang, currentLanguage, i18n]);

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setCurrentLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const changeLanguage = (language) => {
    if (['en', 'fr'].includes(language)) {
      setCurrentLanguage(language);
      i18n.changeLanguage(language);
    }
  };

  const value = {
    currentLanguage,
    changeLanguage,
    availableLanguages: [
      { code: 'en', name: 'English', flag: '🇺🇸' },
      { code: 'fr', name: 'Français', flag: '🇫🇷' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 